import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const inFlightRequestsByBranchId = new Map();

const getTimeBlockBasedonBranchId = async (branchId) => {
    const requestKey = String(branchId ?? '');
    if (inFlightRequestsByBranchId.has(requestKey)) {
        return inFlightRequestsByBranchId.get(requestKey);
    }

    const requestPromise = (async () => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.getTimeBlockBasedonBranch()}${branchId}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!res.ok) {
        return { error: true, message: 'get time block based on branch request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
    })();

    inFlightRequestsByBranchId.set(requestKey, requestPromise);
    requestPromise.finally(() => {
        inFlightRequestsByBranchId.delete(requestKey);
    });

    return requestPromise;
};

export default getTimeBlockBasedonBranchId;